import { Card as AntCard, Col } from 'antd';
import styled, { css } from 'styled-components';
import { ReactComponent as AtRisk16 } from 'assets/svgs/at-risk.svg';
import { withPrivacy } from 'components/atoms/private';
import { HelperText01, Text02 } from 'components/styles';

export const Card = withPrivacy(
  styled(AntCard)`
    height: 112px;

    .ant-card-body {
      display: flex;
      height: 100%;
      padding: var(--spacing-04) var(--spacing-05);
      position: relative;
    }

    .task-more_actions-trigger.ant-dropdown-trigger:not(.ant-dropdown-open) {
      visibility: hidden;
    }

    &:hover {
      .task-more_actions-trigger.ant-dropdown-trigger {
        visibility: visible;
      }
    }
  `,
  css`
    background: var(--private-01);
  `,
);

export const CompletedCard = styled(Card)`
  height: 42px;
`;

export const AtRiskIcon = styled(AtRisk16)`
  position: absolute;
  left: 0;
  top: 10px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: var(--spacing-02);
  width: 100%;
`;

export const AlignFooterElements = css`
  align-items: center;
  display: flex;
`;

export const TaskCardFooterWrapper = styled.div`
  ${HelperText01};
  ${Text02};
  ${AlignFooterElements};
`;

export const TaskCardFooterLeft = styled.div`
  ${AlignFooterElements};
  flex: 1;
  padding-right: var(--spacing-03);
  position: relative;
`;

export const TaskCardFooterRight = styled.div`
  ${AlignFooterElements};

  span {
    ${AlignFooterElements};
  }
`;

export const StatusWrapper = styled.div`
  margin-top: -6px;
  margin-left: -6px;
`;

export const MoreActionsCol = styled(Col)`
  margin-top: calc(var(--spacing-03) * -1);
  margin-right: calc(var(--spacing-04) * -1);
`;
